export default __webpack_public_path__ + "static/media/p4.c21e24e8.JPG";